import React, { Component } from 'react'

const placeholders = [
  { id: 'cardsDark', bg: 'dark' },
  { id: 'cardsLight', bg: 'light' },
  { id: 'coffee', bg: 'dark' },
  { id: 'store', bg: 'light' },
  { id: 'tshirt', bg: 'light' },
  { id: 'mobile', bg: 'light' },
  { id: 'laptop', bg: 'light' }
]


class LogoMockups extends Component {
  renderMockups() {
    return (
     <div className="logo-preview-modal">

        <div className="parallax">

    <div id="group1" className="parallax__group">
      <div className="parallax__layer parallax__layer--back">
        <div className="mockup-container">
          <svg viewBox="0 0 1024 680" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
             <image xlinkHref="mockups/mockup-cards.jpg"
                 width="1024"
                 height="680"
                 x="0"
                 y="0"
             ></image>
              <image
                ref="cardsDark"
                xlinkHref=""
                width="150"
                height="150"
                x="360"
                y="-130"
                transform="rotate(53) skewX(-15)"
                id="mockup-cards-placeholder1"
              ></image>
              <image
                ref="cardsLight"
                xlinkHref=""
                width="150"
                height="150"
                x="440"
                y="-470"
                transform="rotate(44.9) skewX(-20) skewY(3)"
                id="mockup-cards-placeholder2"
              ></image>
          </svg>
        </div>
      </div>
    </div>

    <div id="group3" className="parallax__group">

      <div className="parallax__layer parallax__layer--fore">
      {/*
        <div className="left-box">
          <h1>{ i18n[selectedLanguage]['step-your-brand-mockups-coffee-title'] }</h1>
          <p>
            { i18n[selectedLanguage]['step-your-brand-mockups-coffee-description'] }
          </p>
        </div>
      */}
      </div>

      <div className="parallax__layer parallax__layer--base">
        <div className="mockup-container">
          <svg viewBox="0 0 1020 684" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
              <image xlinkHref="mockups/mockup-coffee3.jpg"
                 width="1020"
                 height="684"
                 x="0"
                 y="0"
             ></image>
              <image
                ref="coffee"
                xlinkHref=""
                width="150"
                height="150"
                x="436"
                y="272"
                opacity="1"
                id="mockup-coffee-placeholder"
              ></image>
          </svg>
        </div>
      </div>

    </div>

    <div id="group4" className="parallax__group">
      <div className="parallax__layer parallax__layer--back">
         <div className="mockup-container">
          <svg viewBox="0 0 990 681" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
              <defs>
                <filter id="f10" x="0" y="0">
                  <feGaussianBlur in="SourceGraphic" stdDeviation="0.2" />
                </filter>
              </defs>
              <image xlinkHref="mockups/mockup-tshirt2.jpg"
                 width="990"
                 height="681"
                 x="0"
                 y="0"
             ></image>
              <image
                ref="tshirt"
                xlinkHref=""
                width="150"
                height="150"
                x="560"
                y="300"
                transform="rotate(-3) skewX(-2)"
                filter="url(#f10)"
                id="mockup-tshirt-placeholder1"
              ></image>
          </svg>
        </div>
      </div>

    </div>

    <div id="group5" className="parallax__group">
      <div className="parallax__layer parallax__layer--base">
         <div className="mockup-container">
          <svg viewBox="0 0 1024 680" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
              <image xlinkHref="mockups/mockup-store.jpg"
                 width="1024"
                 height="680"
                 x="0"
                 y="0"
             ></image>
              <image
                ref="store"
                xlinkHref=""
                width="150"
                height="150"
                x="620"
                y="275"
                id="mockup-store-placeholder"
              ></image>
          </svg>
        </div>
      </div>

      <div className="parallax__layer parallax__layer--fore">
        {/*
        <div className="left-box">
          <h1>{ i18n[selectedLanguage]['step-your-brand-mockups-store-title'] }</h1>
          <p>
            { i18n[selectedLanguage]['step-your-brand-mockups-store-description'] }
          </p>
        </div>
        */}
      </div>

    </div>

    <div id="group6" className="parallax__group">

      <div className="parallax__layer parallax__layer--back">
         <div className="mockup-container">
            <svg viewBox="0 0 1024 682" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
                <image xlinkHref="mockups/mockup-mobile.jpg"
                   width="1024"
                   height="682"
                   x="0"
                   y="0"
               ></image>
                <image
                  ref="mobile"
                  xlinkHref=""
                  width="120"
                  height="120"
                  x="460"
                  y="185"
                  id="mockup-mobile-placeholder"
                ></image>
           </svg>
         </div>
      </div>
    </div>

    <div id="group7" className="parallax__group">

      <div className="parallax__layer parallax__layer--fore">
        {/*
        <div className="center-box-mockup">
          <h1>{ i18n[selectedLanguage]['step-your-brand-mockups-mobile-title'] }</h1>
          <p>
            { i18n[selectedLanguage]['step-your-brand-mockups-mobile-description'] }
          </p>
        </div>
        */}
      </div>

      <div className="parallax__layer parallax__layer--base">
         <div className="mockup-container">
          <svg viewBox="0 0 1024 683" preserveAspectRatio="xMidYMid meet" width="100%" height="100%">
              <image xlinkHref="mockups/mockup-laptop2.jpg"
                 width="1024"
                 height="683"
                 x="0"
                 y="0"
             ></image>
              <image
                ref="laptop"
                xlinkHref=""
                width="180"
                height="180"
                x="425"
                y="320"
                id="mockup-laptop-placeholder"
              ></image>
          </svg>
        </div>
      </div>

    </div>

  </div>

  </div>
    )
  }

  componentDidMount() {
    let { currentLogoPreview } = this.props

    for (let i=0; i<placeholders.length; i+=1) {
      let { id, bg } = placeholders[i]
      let el = this.refs[id]
      if (el) {
        let canvasId = `logo-canvas${currentLogoPreview}`
        if (bg === 'dark') {
          canvasId = `${canvasId}-dark`
        }
        let canvas = document.getElementById(canvasId)
        if (canvas) {
          let dataURL = canvas.toDataURL('image/png')
          el.setAttribute('xlink:href', dataURL)
        }
      }
    }
  }

  render() {
    return this.renderMockups()
  }
}

export default LogoMockups



// WEBPACK FOOTER //
// ./src/components/LogoMockups.js